import { render, staticRenderFns } from "./ProgramViewSidebar.vue?vue&type=template&id=449223df&scoped=true&"
import script from "./ProgramViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ProgramViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProgramViewSidebar.vue?vue&type=style&index=0&id=449223df&lang=scss&scoped=true&"
import style1 from "./ProgramViewSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449223df",
  null
  
)

export default component.exports